import { Accelerator } from "../interfaces/accelerator";
import { Lesson } from "../interfaces/lesson";
import { recordScore } from "../interfaces/recordScore";
import { axiosRequestData } from "./axios";

export function replaceCourseSlug(path: string, courseName: string): string {
  const lessonUrl = removeDomainFromUrl(path);
  const newSlug = slugifyCourseName(courseName);
  if (lessonUrl === '/') {
    return getEmptyCourseUrl(path, courseName);
  }

  const segments = lessonUrl.split("/");
  
  if (segments[1] && segments[1] === 'lessons') {
    const lessonName = segments[2];
    segments[1] = 'courses';
    segments[2] = newSlug;
    segments[3] = lessonName;
  } else if (!segments[2]) {
    segments[2] = newSlug;
  } else {
    segments[2] = newSlug;
  }

  return segments.join("/");
}

function slugifyCourseName(name: string): string {
  return name
    .toLowerCase()
    .normalize("NFD")                
    .replace(/[\u0300-\u036f]/g, "") 
    .replace(/[^a-z0-9\s-]/g, "")   
    .trim()
    .replace(/\s+/g, "-");
}

function getEmptyCourseUrl(url: string, courseName: string): string {
  const path = new URL(url).pathname; 

  const parts = path.split("/").filter(p => p !== ""); 

  if (parts.length === 2 && parts[0] === "courses") {
    const fixedUrl = `/courses/${courseName}/${parts[1]}/`;

    return fixedUrl;
  }

  return '';
}

export const removeDomainFromUrl = (url: string) => {
  return url.replace(/^.*\/\/[^/]+/, '');
}

export const createProductTypeUrl = (baseUrl: string): string => {
  const user = (window as any).pgUser;
  const urlObj = new URL(baseUrl);

  if (user) {
    urlObj.searchParams.append('inf_field_Email', user.user_email || '');
    urlObj.searchParams.append('inf_field_Firstname', user.first_name || '');
    urlObj.searchParams.append('inf_field_Lastname', user.last_name || '');
  }

  urlObj.searchParams.append('utm_medium', 'Member_Direct');

  return urlObj.toString();
};

export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/&/g, '-')
    .replace(/'/g, '')
    .replace(/[\s\W-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}


export const getLessonUrl = (lessonUrl: string, courseName: string): string => {
  console.log(lessonUrl, "lessonUrl", courseName, "course name");

  const path = lessonUrl.replace(/^.*\/\/[^/]+/, '');

  const segments = path.split('/').filter(Boolean);

  const drillIndex = segments.indexOf('drill');

  if (drillIndex !== -1) {
    segments[drillIndex] = 'drills';

    const courseSlug = slugify(courseName);

    segments.splice(drillIndex + 1, 0, courseSlug);

    return '/' + segments.join('/') + '/';
  } else {
    return path;
  }
}

// helpers/utils.ts

export const isDrillsPath = (pathname: string): boolean => {
  const segments = pathname.split('/').filter(Boolean);

  const clubIndex = segments.indexOf('scratch-club');

  return clubIndex !== -1 && segments[clubIndex + 1] === 'drills';
}






export const transformDrillUrl = (url: string): string => {
  const path = url.replace(/^.*\/\/[^/]+/, '');

  const segments = path.split('/').filter(Boolean);

  const clubIndex = segments.indexOf('scratch-club');

  if (clubIndex === -1) {
    return path;
  }

  const newSegments = [...segments];

  newSegments.splice(clubIndex + 1, 0, 'drills');

  if (newSegments.length > clubIndex + 3) {
    newSegments.splice(clubIndex + 3, 1);
  }

  console.log("/" + newSegments.join("/"))

  return '/' + newSegments.join('/');
}


export const getLastPartOfUrl = (url: string) => {
  return url.split('/').filter(entry => entry !== "").pop();
}

export const getTimeFromSeconds = (duration: number) => {
  if (duration >= 3600)
    return new Date(duration * 1000).toISOString().substring(11, 19)
  else
    return new Date(duration * 1000).toISOString().substring(14, 19)

}

export const calculateWatchedLessonsCount = (lessonsList: Lesson[]) => {
  return lessonsList.reduce((acc, el) => el.complete ? acc + 1 : acc, 1);
};
export const calculateWatchedLessons = (acc: Accelerator): number => {
  let totalViewedLessons = 1;
  acc.courses.forEach(course => {
    course.lessons.forEach(lesson => {
      if (!lesson.is_introduction) {
        if (lesson.complete) {
          totalViewedLessons++;
        }
      }
    });
  });
  console.log(totalViewedLessons, "total!");
  return totalViewedLessons;
};

export const transformString = (str: string) => {
  if (str === "true") return "Purchased"
  if (str === "false") return "Not Purchased"
  return str.split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
export const getWsCloseFlag = (): number => {
  let ws_close = 0;
  const pgUser = Object.keys(window).includes("pgUser") ? window.pgUser : null;
  pgUser.flags.forEach((flag: any) => {
    if (typeof (flag) === "object") {
      for (let key in flag) {
        if (key === "ws_close") {
          ws_close = flag[key];
          break;
        }
      }
    }
  });
  return ws_close;
};
// This function mimicks the old logic for deciding whether to show the welcome survey
// See /wp-content/themes/pgm/assets/scripts/survey.js for more details.
export const shouldShowWelcomeSurveyOld = (): boolean => {
  const pgUser = Object.keys(window).includes("pgUser") ? window.pgUser : null;
  if (!pgUser) {
    return false;
  }
  if (pgUser.ws_answers || pgUser.has_seen_welcome_survey) {
    return false;
  }
  const ws_close = getWsCloseFlag();
  // User has closed the popup, show on the third session
  if (ws_close === 1 && pgUser.session !== 3) {
    return false;
  }
  // User has closed the popup for second time, show on the sixth session
  if (ws_close === 2 && pgUser.session !== 6) {
    return false;
  }
  // User has closed the popup for the third time, don't show the popupo
  if (ws_close >= 3) {
    return false;
  }
  return true;
}

export const toggleAutoplay = (autoplayNext: any, cID: any) => {
    if (!autoplayNext) {
        axiosRequestData(
            "DELETE",
            "/wp-json/pg/v2/user/toggle_autoplay",
            { courseID: ""+cID }
        ).then((response) => { });
    } else {
        axiosRequestData(
            "POST",
            "/wp-json/pg/v2/user/toggle_autoplay",
            { courseID: ""+cID }
        ).then((response) => { });
    }
};

export function extractActivePropertyLabels(requestData:recordScore ): string {
  const mapping: { [key: string]: string } = {
      chipping_bunkers_1: "Chipping and Bunkers 2",
      chipping_bunkers_2: "Hole Count",
      putting: "Putts",
      mental_game: "Mental Game",
      wedge_game_1: "Wedge Game 1",
      wedge_game_2: "Wedge Game 2",
      driving: "Driving",
      ball_striking: "Ball Striking"
  };

  const ignoreKeys = ["score", "record_date", "course", "record_id"];

  const result: string[] = [];

  for (const key in requestData) {
      if (!ignoreKeys.includes(key)) {
          const value = requestData[key as keyof typeof requestData];
          if (typeof value === "string" && value.trim() !== "" && mapping[key]) {
              result.push(mapping[key]);
          }
      }
  }

  return result.join(",");
}

export function generateRandomPassword(length: number = 8): string {
    const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let password = "";
    for (let i = 0; i < length; i++) {
        password += chars[Math.floor(Math.random() * chars.length)];
    }
    return password;
}
